import { Popover, Portal, Transition } from '@headlessui/react';
import * as PopperJS from '@popperjs/core';
import type { FC } from 'react';
import { forwardRef, Fragment } from 'react';
import { usePopper } from 'react-popper';
import { twMerge } from 'tailwind-merge';

import type {
  IPopoverButtonProps,
  IPopoverPanelProps,
  IPopoverWrapperProps,
} from './IPopoverProps';

const PopoverWrapper: FC<IPopoverWrapperProps> = ({
  children,
  className,
  ...rest
}) => {
  return (
    <Popover className={twMerge('relative', className)} {...rest}>
      {children}
    </Popover>
  );
};

Popover.displayName = 'PopoverWrapper';

const PopoverButton: FC<IPopoverButtonProps> = forwardRef<
  HTMLButtonElement,
  IPopoverButtonProps
>(({ children, className, ...rest }, forwardedRef) => {
  return (
    <Popover.Button
      className={twMerge('', className)}
      ref={forwardedRef as React.RefObject<HTMLButtonElement>}
      {...rest}
    >
      {children}
    </Popover.Button>
  );
});

PopoverButton.displayName = 'PopoverButton';

const PopoverPanel: React.FC<IPopoverPanelProps> = forwardRef<
  HTMLDivElement,
  IPopoverPanelProps
>(({ children, className, ...rest }, forwardedRef) => {
  return (
    <Transition
      as={Fragment}
      enter="transition ease-out duration-200"
      enterFrom="opacity-0 translate-y-1"
      enterTo="opacity-100 translate-y-0"
      leave="transition ease-in duration-150"
      leaveFrom="opacity-100 translate-y-0"
      leaveTo="opacity-0 translate-y-1"
    >
      <Popover.Panel
        ref={forwardedRef}
        className={twMerge('', className)}
        {...rest}
      >
        {children}
      </Popover.Panel>
    </Transition>
  );
});

PopoverPanel.displayName = 'PopoverPanel';

export {
  PopoverButton,
  PopoverPanel,
  PopoverWrapper,
  PopperJS,
  Portal,
  usePopper,
};
